export const GlobalShortcuts = {
	NavigateToServices: 's+shift',
	NavigateToTraces: 't+shift',
	NavigateToLogs: 'l+shift',
	NavigateToDashboards: 'd+shift',
	NavigateToAlerts: 'a+shift',
	NavigateToExceptions: 'e+shift',
	NavigateToMessagingQueues: 'm+shift',
	ToggleSidebar: 'b+shift',
};

export const GlobalShortcutsName = {
	NavigateToServices: 'shift+s',
	NavigateToTraces: 'shift+t',
	NavigateToLogs: 'shift+l',
	NavigateToDashboards: 'shift+d',
	NavigateToAlerts: 'shift+a',
	NavigateToExceptions: 'shift+e',
	NavigateToMessagingQueues: 'shift+m',
	ToggleSidebar: 'shift+b',
};

export const GlobalShortcutsDescription = {
	NavigateToServices: 'Navigate to Services page',
	NavigateToTraces: 'Navigate to Traces page',
	NavigateToLogs: 'Navigate to logs page',
	NavigateToDashboards: 'Navigate to dashboards page',
	NavigateToAlerts: 'Navigate to alerts page',
	NavigateToExceptions: 'Navigate to Exceptions page',
	NavigateToMessagingQueues: 'Navigate to Messaging Queues page',
	ToggleSidebar: 'Toggle sidebar visibility',
};
